import { Link } from "react-router-dom";
import { Mic, Play, Heart } from "lucide-react";

export function SongCard({ song, index = 0 }) {
  return (
    <Link to={`/song/${song.song_id}`} data-testid={`song-card-${song.song_id}`}
      className="group card-surface rounded-2xl overflow-hidden hover-lift fade-up block"
      style={{ animationDelay: `${(index % 8) * 0.05}s` }}>
      <div className="relative aspect-square overflow-hidden">
        <img src={song.cover_url} alt={song.title} loading="lazy"
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
        <div className="absolute bottom-3 right-3 w-11 h-11 rounded-full bg-neon-pink flex items-center justify-center opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all glow-pink">
          <Mic className="w-5 h-5 text-white" />
        </div>
        <span className="absolute top-3 left-3 text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded-full bg-black/60 backdrop-blur text-neon-cyan">{song.genre}</span>
      </div>
      <div className="p-3.5">
        <h4 className="font-head font-bold text-sm truncate">{song.title}</h4>
        <p className="text-xs text-muted-foreground truncate">{song.artist}</p>
        <p className="text-[11px] text-muted-foreground/70 mt-1">{song.language} · {song.country}</p>
      </div>
    </Link>
  );
}

export function SectionHeader({ title, subtitle, action }) {
  return (
    <div className="flex items-end justify-between mb-5">
      <div>
        <h2 className="font-head text-2xl sm:text-3xl font-extrabold tracking-tight">{title}</h2>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function backendUrl(path) {
  if (!path) return "";
  return path.startsWith("http") ? path : `${process.env.REACT_APP_BACKEND_URL}${path}`;
}
